import type { ClientCoOwnerDto, ClientDetailsDto } from '../dto';
import type { ClientCoOwner, ClientDetails } from '../models';

const mapClientCoOwnerDtoToModel = (dto: ClientCoOwnerDto): ClientCoOwner => ({
  ...dto,
  bankAccounts: dto.bankAccounts ?? [],
  generalData: {
    ...dto.generalData,
    addresses: dto.generalData.addresses ?? [],
  },
});

export const mapClientDetailsDtoToModel = (
  dto: ClientDetailsDto,
): ClientDetails => ({
  ...dto,
  beneficiaries: dto.beneficiaries ?? [],
  coOwners: (dto.coOwners ?? []).map(mapClientCoOwnerDtoToModel),
  portfolioList: dto.portfolioList ?? [],
});
